import "./css/App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./frontend/components/ScrollToTop";
import HomePage from "./frontend/HomePage";
import Footer from "./frontend/components/Footer";
import PrivacyPage from "./frontend/PrivacyPage";
import ContactUsPage from "./frontend/components/ContactUs";
import Header from "./frontend/components/Header";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/*" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
        </Routes>
      </div>
      {/* <div className="primary-box-container" /> */}
      <ContactUsPage />
      <Footer />
    </Router>
  );
}

export default App;
